

// import React, { useEffect, useState } from "react";
// import { useAuth } from "../../context/AuthContext";
// import "../../style/Planeacion.css";
// import axios from "../../api/axiosAuth";
// // 1. IMPORTAMOS LAS CONSTANTES CENTRALIZADAS
// import { API, UPLOADS_URL } from "../config"; 

// const ContenidosEstudiante = () => {
//   const { user } = useAuth();

//   const [contenidos, setContenidos] = useState([]);
//   const [periodos, setPeriodos] = useState([]);
//   const [periodoActivo, setPeriodoActivo] = useState(null);

//   const [materias, setMaterias] = useState([]);
//   const [materiaSeleccionada, setMateriaSeleccionada] = useState("");

//   const [gradoGrupo, setGradoGrupo] = useState(null);
//   const [mensaje, setMensaje] = useState("");

//   // 1️⃣ Obtener grado y grupo del estudiante
//   useEffect(() => {
//     if (user?.grado && user?.grupo) {
//       setGradoGrupo({
//         grado: user.grado,
//         grupo: user.grupo,
//       });
//     } else {
//       setMensaje("No se encontró grado ni grupo asignado al usuario.");
//     }
//   }, [user]);

//   // 2️⃣ Obtener períodos
//   useEffect(() => {
//     const cargarPeriodos = async () => {
//       try {
//         const { data } = await axios.get("/contenidos/periodos", {
//           params: {
//             tenant_id: user.tenant_id,
//             sede_id: user.sede_id,
//           },
//         });

//         setPeriodos(data);
//         setPeriodoActivo(data.find((p) => p.activo === 1) || null);
//       } catch (error) {
//         console.error("❌ Error cargando periodos:", error);
//         setMensaje("No se pudieron cargar los períodos.");
//       }
//     };

//     cargarPeriodos();
//   }, [user]);

//   // 3️⃣ Cargar materias del estudiante
//   useEffect(() => {
//     const cargarMaterias = async () => {
//       if (!gradoGrupo) return;

//       try {
//         const { data } = await axios.get("/contenidos/materias", {
//           params: {
//             grado: gradoGrupo.grado,
//             grupo: gradoGrupo.grupo,
//             tenant_id: user.tenant_id,
//             sede_id: user.sede_id,
//           },
//         });

//         setMaterias(data);

//         if (data.length > 0) {
//           setMateriaSeleccionada(data[0].id);
//         }
//       } catch (error) {
//         console.error("❌ Error cargando materias:", error);
//         setMaterias([]);
//         setMensaje("No se pudieron cargar las materias.");
//       }
//     };

//     cargarMaterias();
//   }, [gradoGrupo, user]);

//   // 4️⃣ Cargar contenidos por materia
//   useEffect(() => {
//     const cargarContenidos = async () => {
//       if (!materiaSeleccionada || !gradoGrupo || !periodoActivo) return;

//       try {
//         const { data } = await axios.get(
//           `/contenidos/materia/${materiaSeleccionada}`,
//           {
//             params: {
//               grado: gradoGrupo.grado,
//               grupo: gradoGrupo.grupo,
//               periodo_id: periodoActivo.id,
//               tenant_id: user.tenant_id,
//               sede_id: user.sede_id,
//             },
//           }
//         );

//         setContenidos(data);
//       } catch (error) {
//         console.error("❌ Error cargando contenidos:", error);
//         setContenidos([]);
//         setMensaje("No se pudieron cargar los contenidos.");
//       }
//     };

//     cargarContenidos();
//   }, [materiaSeleccionada, periodoActivo, gradoGrupo, user]);

//   // =============================
//   // Ver archivo PDF (CORREGIDO)
//   // =============================
//   const handleVerArchivo = (archivo) => {
//     if (archivo) {
//       // Usamos UPLOADS_URL que apunta a la IP de AWS sin puerto
//       window.open(`${UPLOADS_URL}${archivo}`, "_blank");
//     }
//   };

//   // =============================
//   // Descargar archivo (CORREGIDO)
//   // =============================
//   const handleDescargar = (item) => {
//     // Usamos la constante API centralizada
//     const url = `${API}/contenidos/descargar/${item.id}`;
//     const a = document.createElement("a");
//     a.href = url;
//     a.download = item.nombre_original || "archivo";
//     a.click();
//   };

//   return (
//     <div className="contenidos-container">
//       <h2>📘 Mis Guías y Contenidos</h2>

//       {gradoGrupo && (
//         <p>
//           <strong>Grado:</strong> {gradoGrupo.grado} |{" "}
//           <strong>Grupo:</strong> {gradoGrupo.grupo}
//         </p>
//       )}

//       {periodoActivo ? (
//         <p className="activo">
//           📅 Periodo activo: <strong>{periodoActivo.nombre}</strong>
//         </p>
//       ) : (
//         <p className="mensaje">No hay periodo activo.</p>
//       )}

//       <div className="filtros">
//         <label>Seleccione una materia:</label>
//         <select
//           value={materiaSeleccionada}
//           onChange={(e) => setMateriaSeleccionada(e.target.value)}
//         >
//           <option value="">-- Seleccione --</option>
//           {materias.map((m) => (
//             <option key={m.id} value={m.id}>
//               {m.nombre}
//             </option>
//           ))}
//         </select>
//       </div>

//       {mensaje && <p className="mensaje">{mensaje}</p>}

//       <div className="contenidos-lista">
//         {contenidos.length ? (
//           contenidos.map((item) => (
//             <div key={item.id} className="contenido-card">
//               <h4>{item.titulo}</h4>
//               <p>{item.descripcion || "Sin descripción"}</p>

//               <p>
//                 <strong>Materia:</strong> {item.materia_nombre}
//               </p>
//               <p>
//                 <strong>Fecha:</strong>{" "}
//                 {new Date(item.created_at).toLocaleDateString("es-ES")}
//               </p>

//               {item.tipo === "archivo" && (
//                 <div className="acciones">
//                   <button onClick={() => handleVerArchivo(item.archivo)}>
//                     👁️ Ver
//                   </button>
//                   <button onClick={() => handleDescargar(item)}>
//                     💾 Descargar
//                   </button>
//                 </div>
//               )}

//               {item.tipo === "enlace" && (
//                 <a
//                   href={item.enlace}
//                   target="_blank"
//                   rel="noopener noreferrer"
//                 >
//                   🌐 Abrir enlace
//                 </a>
//               )}

//               {item.tipo === "video" && (
//                 <iframe
//                   width="100%"
//                   height="250"
//                   src={item.enlace}
//                   title={item.titulo}
//                   allowFullScreen
//                 ></iframe>
//               )}
//             </div>
//           ))
//         ) : (
//           <p className="mensaje">No hay contenidos disponibles.</p>
//         )}
//       </div>
//     </div>
//   );
// };

// export default ContenidosEstudiante;

//

import React, { useEffect, useState } from "react";
import { useAuth } from "../../context/AuthContext";
import "../../style/Planeacion.css";
import axios from "../../api/axiosAuth";

const ContenidosEstudiante = () => {
  const { user } = useAuth();

  const [contenidos, setContenidos] = useState([]);
  const [materias, setMaterias] = useState([]);
  const [materiaSeleccionada, setMateriaSeleccionada] = useState("");

  const [periodoActivo, setPeriodoActivo] = useState(null);

  const [mensaje, setMensaje] = useState("");
  const [loading, setLoading] = useState(false);

  /* ==========================================
      PERIODO ACTIVO
  ========================================== */

  useEffect(() => {
    if (!user) return;

    const cargarPeriodoActivo = async () => {
      try {
        const { data } = await axios.get(
          "/contenidos/periodo-activo"
        );

        setPeriodoActivo(data || null);

      } catch (error) {

        console.error(error);

        setPeriodoActivo(null);

      }
    };

    cargarPeriodoActivo();

  }, [user]);

  /* ==========================================
      MATERIAS
  ========================================== */

  useEffect(() => {

    if (!user) return;

    const cargarMaterias = async () => {

      try {

        setLoading(true);

        const { data } = await axios.get(
          "/contenidos/materias"
        );

        const lista =
          Array.isArray(data)
            ? data
            : data.materias || [];

        setMaterias(lista);

        if (lista.length > 0) {

          setMateriaSeleccionada(lista[0].id);

        }

      } catch (error) {

        console.error(
          "Error cargando materias",
          error.response?.data || error
        );

        setMaterias([]);

        setMensaje(
          "No se pudieron cargar las materias."
        );

      } finally {

        setLoading(false);

      }

    };

    cargarMaterias();

  }, [user]);

  /* ==========================================
      CONTENIDOS
  ========================================== */

  useEffect(() => {

    if (!materiaSeleccionada) return;

    const cargarContenidos = async () => {

      try {

        setLoading(true);

        const { data } = await axios.get(
          `/contenidos/materia/${materiaSeleccionada}`
        );

        setContenidos(
          data.contenidos || []
        );

      } catch (error) {

        console.error(
          "Error cargando contenidos",
          error.response?.data || error
        );

        setContenidos([]);

        setMensaje(
          "No se pudieron cargar los contenidos."
        );

      } finally {

        setLoading(false);

      }

    };

    cargarContenidos();

  }, [materiaSeleccionada]);

  /* ==========================================
      VER ARCHIVO
  ========================================== */

  const handleVerArchivo = (archivo) => {

    if (!archivo) return;

    window.open(
      archivo,
      "_blank"
    );

  };

  /* ==========================================
      DESCARGAR
  ========================================== */

  const handleDescargar = (archivo) => {

    if (!archivo) return;

    window.open(
      archivo,
      "_blank"
    );

  };

  return (

    <div className="contenidos-container">

      <h2>
        📘 Mis Guías y Contenidos
      </h2>

      {periodoActivo && (

        <p className="activo">

          📅 Periodo activo:

          <strong>
            {" "}
            {periodoActivo.nombre}
          </strong>

        </p>

      )}

      {mensaje && (

        <p className="mensaje">

          {mensaje}

        </p>

      )}

      <div className="filtros">

        <label>

          Materia

        </label>

        <select

          value={materiaSeleccionada}

          onChange={(e)=>
            setMateriaSeleccionada(e.target.value)
          }

        >

          <option value="">

            Seleccione...

          </option>

          {materias.map((m)=>(

            <option
              key={m.id}
              value={m.id}
            >

              {m.nombre}

            </option>

          ))}

        </select>

      </div>

      {loading ? (

        <p>

          Cargando...

        </p>

      ) : contenidos.length === 0 ? (

        <p className="mensaje">

          No hay contenidos disponibles.

        </p>

      ) : (

        <div className="contenidos-lista">

          {contenidos.map((item)=>(

            <div
              key={item.id}
              className="contenido-card"
            >

              <h4>

                {item.titulo}

              </h4>

              <p>

                {item.descripcion || "Sin descripción"}

              </p>

              <p>

                <strong>Materia:</strong>{" "}

                {item.materia}

              </p>

              <p>

                <strong>Periodo:</strong>{" "}

                {item.periodo}

              </p>

              <p>

                <strong>Fecha:</strong>{" "}

                {new Date(
                  item.created_at
                ).toLocaleDateString("es-CO")}

              </p>

              {item.tipo === "archivo" &&
               item.archivo && (

                <div className="acciones">

                  <button
                    onClick={() =>
                      handleVerArchivo(item.archivo)
                    }
                  >
                    👁️ Ver
                  </button>

                  <button
                    onClick={() =>
                      handleDescargar(item.archivo)
                    }
                  >
                    📥 Descargar
                  </button>

                </div>

              )}

              {item.tipo === "enlace" &&
               item.enlace && (

                <a
                  href={item.enlace}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  🌐 Abrir enlace
                </a>

              )}

              {item.tipo === "video" &&
               item.enlace && (

                <iframe
                  width="100%"
                  height="300"
                  src={item.enlace}
                  title={item.titulo}
                  allowFullScreen
                />

              )}

            </div>

          ))}

        </div>

      )}

    </div>

  );

};

export default ContenidosEstudiante;